import v2Fetch from './v2Fetch'

export function getMiniappScheme() {
  return v2Fetch<{ url: string }>('/weixin_app/miniapp_scheme')
}
